import { api } from './api'
import { dayLabel, el } from './ui'

// "Rather we did it? Send us your file" (0039; Liam 1 Oct 2026: moving over must be "pain free,
// enjoyable, clear and reliable", done for you "within 2 working days"). What the import screen, the
// start screen and the diary's welcome card all say once a file has been sent, so the three never
// disagree.

export interface ImportRequest {
  id: number
  file_name: string
  size: number
  note: string | null
  status: 'waiting' | 'done'
  created_at: string
  due_on: string
  done_at: string | null
}

export const SEND_TYPES = ['csv', 'xlsx', 'xls', 'numbers', 'ods', 'pdf', 'sqg'] as const
export const SEND_MAX_BYTES = 10 * 1024 * 1024
export const SENT_WORDS = "We've got your file. Your customers will be in Roundly within 2 working days."

// "That's by Fri 3 Oct."
export function byWords(r: Pick<ImportRequest, 'due_on'>): string {
  return `That's by ${dayLabel(r.due_on)}.`
}

// 1536000 → "1.5 MB", 20480 → "20 KB".
export function sizeWords(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1).replace(/\.0$/, '')} MB`
  return `${Math.max(1, Math.round(bytes / 1024))} KB`
}

// The files this round is waiting on, newest first. A failed read is none: every screen that shows
// this has its own way in without it.
export async function waitingFiles(): Promise<ImportRequest[]> {
  try {
    const r = await api<{ requests: ImportRequest[] }>('/api/import-requests')
    return r.requests.filter((x) => x.status === 'waiting')
  } catch {
    return []
  }
}

// The "We've got your file" card: one line for the promise, one for the day, one naming the file.
export function sentCard(r: ImportRequest): HTMLElement {
  return el(
    'section',
    { class: 'import-card import-sent', role: 'status' },
    el('div', { class: 'import-done-head' }, el('span', { class: 'import-done-tick', 'aria-hidden': 'true' }, '✓'), el('h3', {}, SENT_WORDS)),
    el('p', {}, byWords(r)),
    el('p', { class: 'muted' }, `${r.file_name} (${sizeWords(r.size)})${r.note ? `: ${r.note}` : ''}`),
  )
}
